import DataManager from 'utils/DataManager/dataManager';
import { IAccountDataManager } from 'typings/dataManagers';

class AccountDataManager extends DataManager implements IAccountDataManager{
    async doesMasterAccountHasLab(masterAccountId: string): Promise<boolean> {
        const receive = () => this._getDataRequest<boolean>(`/api/masteraccounts/${masterAccountId}/haslab`);
        return await this.getData<boolean>(receive, false) || false;
    }

    async sendUserInvite(invite: IUserInviteRequest,  masterAccountId: string): Promise<void|null> {
        const receive = () => this._postDataRequest<IUserInviteRequest, void>(
            `/api/masteraccounts/${masterAccountId}/invite`, invite);
        return await this.getData<void|null>(receive, true);
    }
}

export { AccountDataManager };
export default AccountDataManager;